import { __assign } from "tslib";
import { Field } from 'formik';
import * as React from 'react';
import InputMask from 'react-input-mask';
import { Error } from '../../../components';
export var ExistingCustomer = function (_a) {
    var errors = _a.errors, touched = _a.touched, setFieldValue = _a.setFieldValue;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "lastName" }, "Your surname"),
            React.createElement(Field, { id: "lastName", name: "lastName", component: "input", className: "form-control shadow-alt " + (errors.lastName &&
                    touched.lastName &&
                    'error'), onBlur: function (e) {
                    setFieldValue('lastName', e.currentTarget.value.trim());
                } }),
            React.createElement(Error, { name: "lastName" })),
        React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "row col-lg-6" },
                React.createElement("label", { htmlFor: "dateOfBirth" }, "Date of birth"),
                React.createElement(Field, { id: "dateOfBirth", name: "dateOfBirth", render: function (field) { return (React.createElement(InputMask, __assign({}, field.field, { className: "form-control shadow-alt " + (errors.dateOfBirth &&
                            touched.dateOfBirth &&
                            'error'), mask: "99/99/9999", placeholder: "DD/MM/YYYY" }))); } }),
                React.createElement(Error, { name: "dateOfBirth" })))));
};
//# sourceMappingURL=ExistingCustomer.js.map